import axios from "axios";
import Vue from "vue";
import helper from "../../util/helper";

const getDefaultSelectedAgency = () => {
  return {
    unit: {
      parentUnitId: null,
      penName: "",
      deskCode: "",
    },
    office: {
      code: null,
      name: null,
      officeType: null,
      salesChannelId: null,
      active: null,
    },
    // ipAddresses:[],
    agencyContracts: [],
    combinedTrainSchedules: [],
    authPersonId: 0,
    haveBookingRecord: false,
    onlyQuotaSeatsVisible: false,
  };
};

export default {
  state: () => ({
    selectedAgency: getDefaultSelectedAgency(),
    selectedAgencyOrBranch: "AGENCY",
    agencies: [],
  }),
  mutations: {
    setSelectedAgency(state, agency) {
      Vue.set(state, "selectedAgency", agency);
    },
    setSelectedAgencyOrBranch(state, agencyOrBranch) {
      Vue.set(state, "selectedAgencyOrBranch", agencyOrBranch);
    },
    setAgencies(state, agencies) {
      Vue.set(state, "agencies", agencies);
    },
    setDefaultSelectedAgency(state) {
      Vue.set(state, "selectedAgency", getDefaultSelectedAgency());
    },
    setDefaultAgentModule(state) {
      Vue.set(state, "selectedAgency", getDefaultSelectedAgency());
      Vue.set(state, "selectedAgencyOrBranch", "AGENCY");
      Vue.set(state, "agencies", []);
    },
  },
  actions: {
    createAgency: (context, request) => {
      //TODO: Loader start
      return axios
        .post(context.getters.getMcServiceUrl + "/agencies/entity", request, {})
        .then((response) => {
          //TODO: Loader end
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadAgencies: (context) => {
      //TODO: Loader start
      return axios.get(context.getters.getMcServiceUrl + "/agencies/entity").then((response) => {
        return response.data;
      });
    },
    loadPublishedAgencies: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/agencies/entity/published").then((response) => {
        return response.data;
      });
    },
    loadAgency: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/agencies/entity/" + request.id).then((response) => {
        return response.data;
      });
    },

    loadKKYAgencies: (context, request) => {
      //TODO: Loader start
      return axios.post(context.getters.getMcServiceUrl + "/agencies/kky", request, {}).then((response) => {
        //TODO: Loader end
        return response.data;
      });
    },
    setAgencySalesStatus: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/agencies/toggle-active-status/" + request, {}).then((response) => {
        return response.data;
      });
    },

    checkAgencyTransaction: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/agency-account-periods/check-agency-transaction/" + request, {}).then((response) => {
        return response.data;
      });
    },
    checkTrainCombinedStatus: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/agencies/find-parent-by-unit-id/" + request, {}).then((response) => {
        return response;
      });
    },
    getAgencySalesInfoReportPdf: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/agencies-report/generate-pdf", request, {})
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },

    loadAgencyAccountPeriodTransaction: (context, request) => {
      //TODO: Loader start
      return axios.post(context.getters.getMcServiceUrl + "/agencies/get-accounting-period-transaction-view", request, {}).then((response) => {
        //TODO: Loader end
        return response;
      });
    },

    loadAgencyAccountPeriodTransactionV2: (context, request) => {
      return axios.post(context.getters.getMcServiceUrl + "/v2/agencies/get-accounting-period-transaction-view", request, {}).then((response) => {
        return response;
      });
    },

    loadSelectedAgencyHistory: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/agencies/history/" + request.id, {}).then((response) => {
        return response.data;
      });
    },

    selectedAccountPeriodToClose: (context, request) => {
      return axios.post(context.getters.getMcServiceUrl + "/agency-account-periods/close-multiple", request).then((response) => {
        return response.data;
      });
    },
    loadAgencyAccountPeriodsByUnits: (context, request) => {
      return axios.post(context.getters.getMcServiceUrl + "/agency-account-periods/get-by-units", request).then((response) => {
        return response.data;
      });
    },
    loadSelectedAgencyAccountPeriod: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/agency-account-periods/" + request.id, {}).then((response) => {
        return response.data;
      });
    },

    loadAgencyByUnitId: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/agencies/find-by-unitId/" + request.id, {}).then((response) => {
        return response.data;
      });
    },

    loadPeriodActivities: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/agency-activities/" + request.id, {}).then((response) => {
        return response.data;
      });
    },

    getAgencySalesReport: (context, request) => {
      return axios.post(context.getters.getMcServiceUrl + "/agencies-report/get-agency-sales-report", request).then((response) => {
        return response.data;
      });
    },

    getAgencySalesReportV2: (context, request) => {
      return axios.post(context.getters.getMcServiceUrl + "/v2/agencies-report/get-agency-sales-report", request).then((response) => {
        return response.data;
      });
    },

    getAgencySalesReportByDateRange: (context, request) => {
      return axios.post(context.getters.getMcServiceUrl + "/agencies-report/get-agency-sales-report-by-date-range", request).then((response) => {
        return response.data;
      });
    },

    getAgencyPeriodReport: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/agencies-report/get-agency-period-report", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },

    getAgencySalesReportByDateRangeV2: (context, request) => {
      return axios.post(context.getters.getMcServiceUrl + "/v2/agencies-report/get-agency-sales-report-by-date-range", request).then((response) => {
        return response.data;
      });
    },

    getAgencySalesInfoReportPdfV2: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/v2/agencies-report/generate-pdf", request, {})
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },

    getAgencyPeriodReportV2: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/v2/agencies-report/get-agency-period-report", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    putPeriodActivities: (context, request) => {
      return axios
        .put(context.getters.getMcServiceUrl + "/agency-activities", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },

    deletePeriodActivities: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/agency-activities/cancel", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },

    paymentRecord: (context, request) => {
      return axios.post(context.getters.getMcServiceUrl + "/agency-activities/payment-record", request, {}).then((response) => {
        return response;
      });
    },

    deleteAgency: (context, agency) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/agencies/entity/" + agency.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          agency.intents = intents;
          agency.intentId = response.data.id;
          return agency;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteDraftAgency: (context, agency) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/agencies/draft/" + agency.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },

    publishAgency: (context, agency) => {
      return axios.get(context.getters.getMcServiceUrl + "/agencies/publish/" + agency.intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        return response.data;
      });
    },

    rejectAgency: (context, agency) => {
      return axios.get(context.getters.getMcServiceUrl + "/agencies/reject/" + agency.intentId).then((response) => {
        if (agency.intents[0].type === "DELETE_AGENCY") {
          agency.intents = null;
          agency.intentId = 0;
        } else if (agency.intents[0].type === "CREATE_AGENCY") {
          agency.intents[0].status = "DRAFT";
        } else if (agency.intents[0].type === "UPDATE_AGENCY") {
          agency.intents[0].status = "DRAFT";
        }
        return response.data;
      });
    },

    sendToApprovalAgency: (context, agency) => {
      return axios.get(context.getters.getMcServiceUrl + "/agencies/sendToApproval/" + agency.intentId).then((response) => {
        if (agency.intents[0].type === "CREATE_AGENCY") {
          agency.intents[0].status = "WAITING_APPROVAL";
        } else if (agency.intents[0].type === "UPDATE_AGENCY") {
          agency.intents[0].status = "WAITING_APPROVAL";
        }
        return response.data;
      });
    },

    recallAgency: (context, agency) => {
      return axios.get(context.getters.getMcServiceUrl + "/agencies/recall/" + agency.intentId).then((response) => {
        helper.recallOrRejectEntity(agency, "agency");
        return response.data;
      });
    },
    cancelAgency: (context, agency) => {
      return axios.get(context.getters.getMcServiceUrl + "/agencies/cancel/" + agency.intentId).then((response) => {
        return response.data;
      });
    },
    getAgencyByUnitId: (context, request) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/agencies/find-by-unitId/" + request.id, {})
        .then((response) => {
          context.commit("setSelectedAgency", response.data);
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadAgencyGetPartialUnitTree: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/units/agency-get-partial-unit-tree-with-office-id/" + request.id, {}).then((response) => {
        return response;
      });
    },
    loadAgencyBranchesByUnitId: (context, request) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/agencies/find-branches-by-unitId/" + request.unitId, {})
        .then((response) => {
          //TODO: Loader end
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    setBranchOfficeSalesLimit: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/agencies/set-branch-office-sales-limit", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    closeAgencyAccountPeriod: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/agency-account-periods/close", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    getPeriodEndResultsInformationPdf: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/agencies-report/agency-period-result-report-generate-pdf", request)
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
  },

  getters: {
    getSelectedAgency: (state) => {
      return state.selectedAgency;
    },
    getSelectedAgencyOrBranch: (state) => {
      return state.selectedAgencyOrBranch;
    },
    getAgencies: (state) => {
      return state.agencies;
    },
  },
};
